/**
 * `new Ractive(options)` --> ractive view
 *
 * An airship specific constructor for Ractive views. This module allows us
 * to set any global filters, and template defaults.
 *
 * Docs: http://docs.ractivejs.org/latest/get-started
 */

const Ractive = require('ractive/runtime')

// Setting Debug to false to avoid console warnings, this can be toggled during
// dev to get debug assistance from Ractive.
Ractive.DEBUG = false

// This default is necessary to allow for calling functions in Ractive templates
// that are defined directly on the Ractive instance instead of inside of `data`.
Ractive.defaults.resolveInstanceMembers = true

module.exports = Ractive
